export default __webpack_public_path__ + "static/media/pdf_icon.f728652e.svg";